import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import env from '../misc/env';
import { createIamAPI } from './API';
import UserData from './UserData';
var UserDataStore = /*#__PURE__*/function (_Store) {
  function UserDataStore() {
    var _this;
    _classCallCheck(this, UserDataStore);
    _this = _callSuper(this, UserDataStore, arguments);
    _this.userData = _this.collection({
      model: UserData,
      idAttribute: 'user_public_id'
    });
    _this.api = createIamAPI({
      baseURL: env.IAM_API,
      getToken: _this.rootStore.authStore.getToken
    });
    return _this;
  }
  _inherits(UserDataStore, _Store);
  return _createClass(UserDataStore, [{
    key: "getByPublicId",
    value: function () {
      var _getByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(publicId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.userData.getByPublicId(publicId).then(this.userData.set));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getByPublicId(_x) {
        return _getByPublicId.apply(this, arguments);
      }
      return getByPublicId;
    }()
  }, {
    key: "updateByPublicId",
    value: function () {
      var _updateByPublicId = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(publicId, payload) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.api.userData.updateByPublicId(publicId, payload).then(function () {
                return _this2.getByPublicId(publicId);
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function updateByPublicId(_x2, _x3) {
        return _updateByPublicId.apply(this, arguments);
      }
      return updateByPublicId;
    }()
  }]);
}(Store);
export { UserDataStore as default };
//# sourceMappingURL=UserDataStore.js.map
